import { getGtag } from "@/lib/gtag";

/** Send a custom event to Google Analytics (only if user has granted consent). */
export function trackEvent(
  eventName: string,
  params?: Record<string, string | number>,
) {
  try {
    if (localStorage.getItem("cookie-consent") !== "granted") return;
  } catch {
    return;
  }
  const gtag = getGtag();
  if (gtag) {
    gtag("event", eventName, params);
  }
}
